import {Modal, Select, Radio, Input, Button, message} from 'antd';
import styles from './Modals.module.scss';

const {Option} = Select;
const {TextArea} = Input;

export const EscalationModal = ({visible, onClose, onSubmit}) => {
  const handleSubmit = () => {
    message.success('Ticket escalated successfully.');
    onSubmit();
    onClose();
  };

  return (
    <Modal
      title="Escalate Ticket"
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" danger onClick={handleSubmit}>
          Confirm Escalation
        </Button>,
      ]}>
      <div className={styles.modalContent}>
        <div className={styles.inputBlock}>
          <label>Escalation Reason</label>
          <Select placeholder="Select Reason" style={{width: '100%'}}>
            <Option value="Reconciliation Failure">
              Reconciliation Failure
            </Option>
            <Option value="Fraud Suspicion">Fraud Suspicion</Option>
            <Option value="Compliance Flag">Compliance Flag</Option>
            <Option value="Missing Funds">Missing Funds</Option>
            <Option value="Repeated Failure">Repeated Failure</Option>
            <Option value="User Requested">User Requested</Option>
            <Option value="Emotional Distress">Emotional Distress</Option>
            <Option value="Legal Threat">Legal Threat</Option>
            <Option value="Other">Other</Option>
          </Select>
        </div>

        <div className={styles.inputBlock}>
          <label>Priority</label>
          <Radio.Group defaultValue="Medium">
            <Radio value="Low">Low</Radio>
            <Radio value="Medium">Medium</Radio>
            <Radio value="High">High</Radio>
            <Radio value="Critical">Critical</Radio>
          </Radio.Group>
        </div>

        <div className={styles.inputBlock}>
          <label>Route to Team</label>
          <Select placeholder="Select Team" style={{width: '100%'}}>
            <Option value="support-tier1">Support Tier 1</Option>
            <Option value="compliance">Compliance</Option>
            <Option value="success-senior">Success Senior</Option>
            <Option value="finops">FinOps</Option>
          </Select>
        </div>

        <div className={styles.inputBlock}>
          <label>Note for the receiving agent</label>
          <TextArea
            rows={3}
            placeholder="Add context to why this is being escalated..."
          />
        </div>
      </div>
    </Modal>
  );
};
